module.exports = __webpack_public_path__ + "static/media/flag-ro.cda016c0.webp";